module.exports = __webpack_public_path__ + "files/84deaac3db2377d60f00933165b58146.png";